import React from 'react';
import { Button, SparkIcon } from '@spark';

/**
 * Top-bar entry for Admins while a newer version is on offer; it stays after the
 * popup is closed. Styled like the MVP top bar's "Upgrade to Pro" (Figma 9151:4841).
 */
export default function UpdateButton({ upgrader }) {
    if (!upgrader.isAdmin || !upgrader.offer || upgrader.upgrade) return null;
    return (
        <Button
            variant="primary"
            size="medium"
            type="button"
            startIcon={<SparkIcon slug="out" size="medium" />}
            onClick={upgrader.startUpdateFlow}
        >
            Update
        </Button>
    );
}
